// ═══════════════════════════════════════════════════════════════
// Qué dice "¡Apuesta registrada!" sobre el pago
// ═══════════════════════════════════════════════════════════════
//
// La apuesta de la app se paga de tres maneras (ver `enviarApuesta` en
// App.jsx): 'saldo' y 'bono' se descuentan en el momento y la apuesta
// queda confirmada; 'reservada' —y el código generado, que llega sin
// modo— se paga en efectivo en el mostrador. Solo a esos últimos les
// corresponde el aviso de efectivo: a quien ya pagó con su saldo, pedirle
// que vaya a pagar a la agencia lo confunde.

export const TEXTO_EFECTIVO =
  "El boleto queda reservado 24 horas. Pagalo en efectivo en la agencia.";

export function avisoDePago(modo) {
  if (modo === "saldo") {
    return {
      efectivo: false,
      icono: "circle-check",
      texto: "Pagada con tu saldo. Tu apuesta ya está confirmada.",
    };
  }
  if (modo === "bono") {
    return {
      efectivo: false,
      icono: "circle-check",
      texto: "Pagada con tu bono. Tu apuesta ya está confirmada.",
    };
  }
  return { efectivo: true, icono: "clock-3", texto: TEXTO_EFECTIVO };
}
